export const MILEAGE_REPORTS_LIST_RELOADING = 'MILEAGE_REPORTS_LIST_RELOADING'
export const MILEAGE_REPORTS_LIST_UPDATE = 'MILEAGE_REPORTS_LIST_UPDATE'

export const MILEAGE_REPORT_UPDATE_PROPS = 'MILEAGE_REPORT_UPDATE_PROPS'
export const MILEAGE_REPORT_CLEAR_FORM = 'MILEAGE_REPORT_CLEAR_FORM'
